import { render, staticRenderFns } from "./AllLoanTransactions.vue?vue&type=template&id=6c7d8f18&scoped=true"
import script from "./AllLoanTransactions.vue?vue&type=script&lang=js"
export * from "./AllLoanTransactions.vue?vue&type=script&lang=js"
import style0 from "./AllLoanTransactions.vue?vue&type=style&index=0&id=6c7d8f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7d8f18",
  null
  
)

export default component.exports